<div class="flex">
    <p-button label="Add a New Role" [rounded]="true" class="add-role-button" (click)="showAddRoleDialog()" />
</div>
<p-dialog header="Add a New Role" [closable]="false" [modal]="true" [(visible)]="addRoleDialogVisible"
    [style]="{ width: '25rem' }">
    <div class="flex flex-col mb-8">
        <label for="email" class="form-label">Role Name</label>
        <input type="text" pInputText [(ngModel)]="roleName" />
        <span *ngIf="showRoleNameErrorMsg" class="text-red-500">Role Name is required.</span>
    </div>
    <div class="flex justify-end gap-2">
        <p-button label="Cancel" [rounded]="true" severity="secondary" (click)="closeAddRoleDialog('cancel')" />
        <p-button label="Save" [rounded]="true" (click)="closeAddRoleDialog('save')" />
    </div>
</p-dialog>

<p-dialog header="Delete Role" [modal]="true" [(visible)]="deleteRoleDialogVisible" [style]="{ width: '25rem' }">
    <div class="flex flex-col mb-8">
        Do you want to delete the role "{{currentRoleName}}"?
    </div>
    <div class="flex justify-end gap-2">
        <p-button label="Cancel" [rounded]="true" severity="secondary" (click)="closeDeleteRoleDialog('cancel')" />
        <p-button label="Delete" [rounded]="true" (click)="closeDeleteRoleDialog('delete')" />
    </div>
</p-dialog>

<p-dialog header="Warning" [modal]="true" [(visible)]="saveRoleFailedDialogVisible" [style]="{ width: '25rem' }">
    <div class="flex flex-col mb-8">
        Save failed, Please fill in all fields and try again.
    </div>
    <div class="flex justify-end gap-2">
        <p-button label="Confirm" [rounded]="true" (click)="closeSaveRoleFailedDialog()" />
    </div>
</p-dialog>

<p-dialog header="Warning" [modal]="true" [(visible)]="validateRoleBaseFailedDialogVisible"
    [style]="{ width: '45rem' }">
    <div class="flex flex-col mb-8">
        Please ensure the Max Base (CNY) is greater than the Min Base (CNY).
    </div>
    <div class="flex justify-end gap-2">
        <p-button label="Confirm" [rounded]="true" (click)="closeValidateRoleBaseFailedDialog()" />
    </div>
</p-dialog>

<div class="item-section" *ngFor="let role of roles; index as i">
    <div class="flex items-center justify-between">
        <span class="roleName">{{role.roleName}}</span>
        <div class="flex justify-end gap-2" *ngIf="role.action == 'view'">
            <p-button label="Delete" [rounded]="true" severity="secondary" (click)="handleDeleteRole(i)" />
            <p-button label="Edit" [rounded]="true" (click)="handleEditRole(i)" />
        </div>
    </div>
    <div class="mt-4 role-table">
        <p-table [value]="role.data">
            <ng-template #header>
                <tr>
                    <th style="width: 16%">Base</th>
                    <th style="width: 14%">I - Junior</th>
                    <th style="width: 14%">II - Mid</th>
                    <th style="width: 14%">III - Senior</th>
                    <th style="width: 14%">IV - Staff</th>
                    <th style="width: 14%">V - Principle</th>
                    <th style="width: 14%">Lead/Manager</th>
                </tr>
            </ng-template>
            <ng-template #body let-item class="form-item" let-rowIndex="rowIndex">
                <tr *ngIf="role.action == 'edit'">
                    <td>
                        <span [ngClass]="rowIndex == 0 ? 'min-color' : 'max-color'">{{item.base}}</span>
                    </td>
                    <td>
                        <input type="text" pInputText [(ngModel)]="item[1]" [imask]="CNYMask" />
                    </td>
                    <td>
                        <input type="text" pInputText [(ngModel)]="item[2]" [imask]="CNYMask" />
                    </td>
                    <td>
                        <input type="text" pInputText [(ngModel)]="item[3]" [imask]="CNYMask" />
                    </td>
                    <td>
                        <input type="text" pInputText [(ngModel)]="item[4]" [imask]="CNYMask" />
                    </td>
                    <td>
                        <input type="text" pInputText [(ngModel)]="item[5]" [imask]="CNYMask" />
                    </td>
                    <td>
                        <input type="text" pInputText [(ngModel)]="item[6]" [imask]="CNYMask" />
                    </td>
                </tr>
                <tr *ngIf="role.action == 'view'">
                    <td>
                        <span [ngClass]="rowIndex == 0 ? 'min-color' : 'max-color'">{{ item.base }}</span>
                    </td>
                    <td>{{ item[1] | currency:'CNY':'symbol-narrow':'1.0-0'}}</td>
                    <td>{{ item[2] | currency:'CNY':'symbol-narrow':'1.0-0'}}</td>
                    <td>{{ item[3] | currency:'CNY':'symbol-narrow':'1.0-0'}}</td>
                    <td>{{ item[4] | currency:'CNY':'symbol-narrow':'1.0-0'}}</td>
                    <td>{{ item[5] | currency:'CNY':'symbol-narrow':'1.0-0'}}</td>
                    <td>{{ item[6] | currency:'CNY':'symbol-narrow':'1.0-0'}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div class="flex justify-end mt-4 gap-4" *ngIf="role.action == 'edit'">

        <i class="fa fa-xmark delete-icon" (click)="handleDiscardChangesForRole(i)"></i>
        <i class="fa fa-check save-icon" (click)="handleSaveRole(i)"></i>
    </div>
</div>